<template>
  <div class="ViewsLayout">
    <div class="headerWrap" style="background: #ffffff">
      <div
        class="head_system_notice"
        v-if="systemNoticePolling.alter_notice_id !== 0"
        @click="$router.push('/systemnotice/' + systemNoticePolling.alter_notice_id)"
      >
        <img src="@/assets/systemNotice/notice.png" alt>
        <img src="@/assets/systemNotice/notice.png" alt>
        <img src="@/assets/systemNotice/notice.png" alt>
        {{ systemNoticePolling.alter_notice_title }}
      </div>
      <div class="header">
        <div class="tabBar">
          <span>
            <img
              src="@/assets/logo.png"
              style="margin-right: 60px"
              @click="$router.push('/home')"
              class="hover"
            >
          </span>
          <!-- <div style="display: flex; flex-flow: row;">
            <img src="@/assets/beta.png" />
            <div style="color: #FFA200; margin-left: 4px; font-size: 14px; font-weight: 500">Beta</div>
          </div>-->
        </div>
        <div class="userName">
          <a-select
            v-model="cur"
            style="margin-right: 10px; width: 85px !important;"
            @change="curChange"
            :filter-option="filterOption"
            show-search
          >
            <a-select-option v-for="item in curList" :key="item.value" :value="item.value">
              {{
              item.label
              }}
            </a-select-option>
          </a-select>
          <span class="cart-sp" @click="$router.push('/systemnotice')">
            <img src="@/assets/viewsLayout/systemNotice.png" style="margin-right: 26px">
            <div
              class="badge-wrap"
              v-if="systemNoticePolling && systemNoticePolling.user_unread_notices > 0"
            >
              <a-badge :count="systemNoticePolling.user_unread_notices"/>
            </div>
          </span>
          <span class="cart-sp" @click="$router.push('/cart')">
            <img src="@/assets/viewsLayout/cart.png" style="margin-right: 26px">
            <div class="badge-wrap" v-if="+cartTotal > 0">
              <a-badge :count="cartTotal"/>
            </div>
          </span>
          <div>
            <a-dropdown :trigger="['hover']">
              <a
                class="ant-dropdown-link"
                style="color: #4b9bdf; white-space: nowrap; margin-left: 26px"
                @click="e => e.preventDefault()"
              >
                <img
                  :src="info.avatar"
                  height="25"
                  width="25"
                  style="border-radius: 45px; vertical-align: middle"
                >
                <span
                  style="padding-left: 5px; color: #666666; font-size: 16px; vertical-align: middle;"
                  class="userNameText"
                >{{ info.username }}</span>
                <a-icon
                  style="font-size: 16px; margin-left: 6px; font-weight: bold; font-size: 16px; vertical-align: middle"
                  type="down"
                />
              </a>
              <div class="overlay-wrap" slot="overlay">
                <div class="info-wrap">
                  <div class="top-wrap" @click="$router.push('/personal_center/paydetail')">
                    <span class="info-name">Balance($)</span>
                    <span style="flex: 1; padding-left: 6px;">
                      <a style="color: #4b9bdf;">{{ balance }}</a>
                    </span>
                  </div>
                  <div class="top-wrap">
                    <span class="info-name" @click="$router.push('/')">Home Page</span>
                    <span></span>
                  </div>
                  <div class="top-wrap" @click="loginOut">
                    <span class="info-name">Log Out</span>
                    <span>
                      <a-icon type="logout" class="out-icon"/>
                    </span>
                  </div>
                </div>
              </div>
            </a-dropdown>
          </div>
        </div>
      </div>
      <div class="header-mobile">
        <div class="h-left">
          <a-icon type="menu-unfold" @click="drawVisible = true"/>
          <img src="@/assets/logo.png" class="hover logo" @click="$router.push('/home')">
        </div>
        <div class="h-right">
          <span class="cart-sp" @click="$router.push('/systemnotice')">
            <img src="@/assets/viewsLayout/systemNotice.png" style="margin-right: 20px">
            <div
              class="badge-wrap"
              v-if="systemNoticePolling && systemNoticePolling.user_unread_notices > 0"
            >
              <a-badge :count="systemNoticePolling.user_unread_notices"/>
            </div>
          </span>
          <span class="cart-sp" @click="$router.push('/cart')">
            <img src="@/assets/viewsLayout/cart.png" style="margin-right: 26px">
            <div class="badge-wrap" v-if="+cartTotal > 0">
              <a-badge :count="cartTotal"/>
            </div>
          </span>
          <span>{{ info.username }}</span>
          <a-icon type="user" @click="$router.push('/user/login')"/>
        </div>
      </div>
    </div>
    <div class="content" v-if="!isMobile">
      <a-layout>
        <a-layout-sider class="layout_sider" width="240">
          <a-menu mode="inline" @click="selectMenu" :selected-keys="[select_key]">
            <a-menu-item key="1">
              <img src="@/assets/viewsLayout/main_select.png" v-if="select_key === '1'">
              <img src="@/assets/viewsLayout/main.png" v-else>
              <span style="margin-left: 10px">{{ $t('main.mainMenu') }}</span>
            </a-menu-item>
            <a-sub-menu key="2">
              <span slot="title">
                <img
                  src="@/assets/viewsLayout/order_select.png"
                  v-if="select_key === '25' || select_key === '26'"
                >
                <img src="@/assets/viewsLayout/order.png" v-else>
                <span style="margin-left: 10px">{{ $t('main.order') }}</span>
              </span>
              <a-menu-item key="25">
                <span>Order List</span>
              </a-menu-item>
              <a-menu-item key="26">
                <span>Order Import</span>
              </a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="3">
              <span slot="title">
                <img
                  src="@/assets/viewsLayout/designs_select.png"
                  v-if="select_key === '4' || select_key === '5'"
                >
                <img src="@/assets/viewsLayout/designs.png" v-else>
                <span style="margin-left: 10px">{{ $t('main.designs') }}</span>
              </span>
              <a-menu-item key="4">
                <span>Product Template</span>
              </a-menu-item>
              <a-menu-item key="5">
                <span>Print Files</span>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item key="23">
              <img src="@/assets/products/sc_on.png" width="20" v-if="select_key === '23'">
              <img src="@/assets/products/sc_nor.png" width="20" v-else>
              <span style="margin-left: 10px">My Favorites</span>
            </a-menu-item>
            <a-menu-item key="20">
              <img src="@/assets/viewsLayout/brand_select.png" v-if="select_key === '20'">
              <img src="@/assets/viewsLayout/brand.png" v-else>
              <span style="margin-left: 10px">Branding Options</span>
            </a-menu-item>
            <a-menu-item key="16">
              <img src="@/assets/viewsLayout/amazon_select.png" v-if="select_key === '16'">
              <img src="@/assets/viewsLayout/amazon.png" v-else>
              <span style="margin-left: 10px">Amazon Listing Exporter</span>
            </a-menu-item>
            <!-- <a-menu-item key="6">
              <img src="@/assets/viewsLayout/stores_select.png" v-if="select_key === '6'" />
              <img src="@/assets/viewsLayout/stores.png" v-else />
              <span style="margin-left: 10px">{{ $t('main.stores') }}</span>
            </a-menu-item>-->
            <a-menu-item key="66">
              <img src="@/assets/viewsLayout/stores_select.png" v-if="select_key === '66'">
              <img src="@/assets/viewsLayout/stores.png" v-else>
              <span style="margin-left: 10px">Stores(Customize Publish)</span>
            </a-menu-item>
            <a-menu-item key="11">
              <img src="@/assets/viewsLayout/coupon_select.svg" v-if="select_key === '11'">
              <img src="@/assets/viewsLayout/coupon.svg" v-else>
              <span style="margin-left: 10px">{{ $t('main.coupon') }}</span>
            </a-menu-item>
            <a-menu-item key="17">
              <img src="@/assets/viewsLayout/file_select.png" v-if="select_key === '17'">

              <img src="@/assets/viewsLayout/file.png" v-else>
              <span style="margin-left: 10px">File</span>
            </a-menu-item>

            <a-sub-menu key="7">
              <span slot="title">
                <img
                  src="@/assets/viewsLayout/billing_select.png"
                  v-if="select_key === '21' || select_key === '22' || select_key === '15'"
                >
                <img src="@/assets/viewsLayout/billing.png" v-else>
                <span style="margin-left: 10px">{{ $t('main.billing') }}</span>
              </span>
              <!-- <a-menu-item key="24">
                <span>My Wallet</span>
              </a-menu-item>-->
              <a-menu-item key="21">
                <span>Transaction Record</span>
              </a-menu-item>
              <a-menu-item key="22">
                <span>Balance Details</span>
              </a-menu-item>
              <a-menu-item key="15">
                <span>Invoice and IOSS</span>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item key="18">
              <template v-if="select_key === '18'">
                <a-icon style="font-size: 18px;margin-right: 0;color:#FFA200" type="bell"/>
              </template>
              <template v-else>
                <a-icon style="font-size: 18px;margin-right: 0;" type="bell"/>
              </template>

              <span style="margin-left: 10px">Notifications</span>
            </a-menu-item>
            <a-menu-item key="8">
              <img src="@/assets/viewsLayout/affiliateProgram_select.png" v-if="select_key === '8'">
              <img src="@/assets/viewsLayout/affiliateProgram.png" v-else>
              <span style="margin-left: 10px">{{ $t('main.affiliateProgram') }}</span>
            </a-menu-item>
            <a-sub-menu key="12">
              <span slot="title">
                <img
                  src="@/assets/viewsLayout/setting_select.svg"
                  v-if="select_key === '13' || select_key === '14'"
                >
                <img src="@/assets/viewsLayout/setting.svg" v-else>
                <span style="margin-left: 10px">Setting</span>
              </span>
              <a-menu-item key="13">
                <span>Account Details</span>
              </a-menu-item>
              <a-menu-item key="14">
                <span>Address Book</span>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item
              key="9"
              style="position: fixed; bottom: 35px; width: 200px; background: #fff;"
            >
              <img src="@/assets/viewsLayout/home.png">
              <span style="margin-left: 10px">Home Page</span>
            </a-menu-item>
            <a-menu-item
              key="10"
              style="position: fixed; bottom: 0px; width: 200px; background: #fff;"
            >
              <img src="@/assets/viewsLayout/product.png">
              <span style="margin-left: 10px">Product</span>
            </a-menu-item>
          </a-menu>
        </a-layout-sider>
        <a-layout-content class="layout_content">
          <keep-alive :include="['GoodsLibrary']">
            <router-view :key="routerIndex" @changeMenu="handleChangeMenu($event)"/>
          </keep-alive>
        </a-layout-content>
      </a-layout>
    </div>
    <div class="content-mobile" v-else>
      <div class="layout_content">
        <keep-alive :include="[]">
          <router-view/>
        </keep-alive>
      </div>
    </div>
    <ViewDraw :visible="drawVisible" @onclose="drawVisible = false"/>
  </div>
</template>

<script>
import Vue from 'vue'
import viewModal from '@/views/bulletin/components/viewModal.vue'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import Tip from './tip'
import RenderMenu from './components/menu.js'
import { curList } from '@/utils/const'
import ViewDraw from './components/viewDraw'
import { getBalance } from '@/api/apply'
export default {
  name: 'ViewsLayout',
  data() {
    return {
      loading: false,
      select_key: '1',
      routerIndex: 0,
      curList: curList,
      drawVisible: false,
      balance: 0
    }
  },
  watch: {
    $route(to, from) {
      this.getSelectKey(to.name)
    }
  },

  methods: {
    ...mapActions(['Logout', 'getCartData', 'getGroup', 'GetCurList', 'GetRate', 'GetSystemNoticePolling']),
    ...mapMutations({
      setCur: 'SET_CUR'
    }),
    getSelectKey(name) {
      switch (name) {
        case 'main':
          this.select_key = '1'
          break
        case 'order':
          this.select_key = '25'
          break
        case 'productTemplate':
          this.select_key = '4'
          break
        case 'printFiles':
          this.select_key = '5'
          break
        case 'stores':
          this.select_key = '6'
          break
        case 'billing':
          this.select_key = '21'
          break
        case 'affiliateProgram':
          this.select_key = '8'
          break
        case 'apply':
          this.select_key = '8'
          break
        case 'coupon':
          this.select_key = '11'
          break
        case 'accountDetails':
          this.select_key = '13'
          break
        case 'addressBook':
          this.select_key = '14'
          break
        case 'iossNumber':
          this.select_key = '15'
          break
        case 'amazonExport':
          this.select_key = '16'
          break
        case 'file':
          this.select_key = '17'
          break
        case 'systemNotice':
          this.select_key = '18'
          break
        case 'brand':
          this.select_key = '20'
          break
        case 'brandType':
          this.select_key = '20'
          break
        case 'payDetail':
          this.select_key = '22'
          break
        case 'myFavorites':
          this.select_key = '23'
          break
        case 'myWallet':
          this.select_key = '24'
          break
        case 'orderImport':
          this.select_key = '26'
          break
        default:
          break
      }
    },
    loginOut() {
      this.Logout()
    },
    changeRoute(obj, url) {
      if (this.$route.path === url && obj.key === this.select_key) {
        this.routerIndex++
      } else {
        this.select_key = obj.key
        this.$router.push(url)
      }
    },
    selectMenu(obj) {
      switch (obj.key) {
        case '1':
          this.changeRoute(obj, '/personal_center/guide')
          break
        case '25':
          this.changeRoute(obj, '/personal_center/orderList')
          break
        case '4':
          this.changeRoute(obj, '/personal_center/producttemplate')
          break
        case '5':
          this.changeRoute(obj, '/personal_center/printfiles')
          break
        case '6':
          this.changeRoute(obj, '/personal_center/stores')
          break
        case '66':
          this.changeRoute(obj, '/personal_center/newstores')
          break
        case '8':
          const { has_application_form } = this.userInfo
          if (has_application_form === 1) {
            this.changeRoute(obj, '/personal_center/apply')
          } else {
            this.changeRoute(obj, '/personal_center/affiliateprogram')
          }

          break
        case '9':
          this.changeRoute(obj, '/home')
          break
        case '10':
          this.changeRoute(obj, '/products')
          break
        case '11':
          this.changeRoute(obj, '/personal_center/coupon')
          break
        case '13':
          this.changeRoute(obj, '/personal_center/accountdetails')
          break
        case '14':
          this.changeRoute(obj, '/personal_center/addressbook')
          break
        case '15':
          this.changeRoute(obj, '/personal_center/iossnumber')
          break
        case '16':
          this.changeRoute(obj, '/personal_center/amazon_export')
          break
        case '17':
          this.changeRoute(obj, '/personal_center/file')
          break
        case '18':
          this.changeRoute(obj, '/systemnotice')
          break
        case '20':
          this.changeRoute(obj, '/personal_center/brand')
          break
        case '21':
          this.changeRoute(obj, '/personal_center/billing')
          break
        case '22':
          this.changeRoute(obj, '/personal_center/paydetail')
          break
        case '23':
          this.changeRoute(obj, '/personal_center/myfavorites')
          break
        case '24':
          this.changeRoute(obj, '/personal_center/mywallet')
          break
        case '26':
          this.changeRoute(obj, '/personal_center/orderimport')
          break
        default:
          break
      }
    },
    curChange(value) {
      this.setCur(value)
      Vue.ls.set('cur', value)
      this.GetRate()
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChangeMenu(e) {
      this.selectMenu(e)
    }
  },
  components: {
    viewModal,
    Tip,
    RenderMenu,
    ViewDraw
  },
  computed: {
    ...mapState({
      info: state => state.user.info,
      routers: state => state.user.routers,
      cartTotal: state => state.user.cartTotal,
      parentIdMap: state => state.user.parentIdMap,
      groupData: state => state.user.groupData,
      userInfo: state => state.user.info,
      cur: state => state.user.cur,
      systemNoticePolling: state => state.user.systemNoticePolling
    }),
    ...mapGetters(['rightMenu', 'getCur']),
    isMobile() {
      return window.innerWidth < 960
    }
  },
  mounted() {
    this.getCartData()
    this.GetSystemNoticePolling()
  },
  created() {
    if (Vue.ls.get('cur')) {
      this.setCur(Vue.ls.get('cur'))
      this.GetRate()
    }
    // 刷新获取
    this.getSelectKey(this.$route.name)
    getBalance().then(res => {
      this.balance = res.data.balance
    })
  }
}
</script>

<style lang="less" scoped>
.overlay-wrap {
  overflow: hidden;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  .info-wrap {
    // height: 170px;
    padding: 10px 0;
    .top-wrap {
      position: relative;
      padding: 6px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      word-break: break-all;
      .info-name {
        font-size: 16px;
        color: #333;
      }
    }
    .vip-wrap {
      padding: 30px 20px;
      .vip-box {
        display: flex;
        .vip-bg {
          position: relative;
          flex: 1;
          height: 12px;
          border-radius: 6px;
          background-color: rgba(0, 0, 0, 0.2);
          box-shadow: 0 0 10px rgba(3, 56, 130, 0.3);
          .vip-slider {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 12px;
            border-radius: 6px;
            background-color: #fff;
            // background-image: linear-gradient(to right, #ffea37, #fff7e6);
          }
        }
        .vip-bl {
          padding-left: 10px;
          font-size: 12px;
          color: #fff;
          line-height: 1;
        }
      }
    }
  }
  .router-box {
    padding: 10px 0;
    cursor: pointer;
    .router-item {
      margin: 10px 0;
      float: left;
      width: 20%;
      border-right: 1px solid #e4e4e4;
      text-align: center;
      &:nth-of-type(5n) {
        border-right: 0;
      }
      p {
        margin: 10px 0 0 0;
        font-size: 12px;
        color: #666;
      }
    }
  }
}
.header {
  // width: 1400px;
  min-width: 1400px;
  padding: 0 30px;
  // width: 100%;
  height: 66px;
  margin: 0 auto;
  // padding: 0 142px;
  // padding-left: 140px;
  // padding-right: 53px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .userName {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cart-sp {
      position: relative;
      cursor: pointer;
      .badge-wrap {
        position: absolute;
        top: -10px;
        right: 10px;
      }
    }
  }
}
.header-mobile {
  display: none;
  height: 44px;
  background: #ffffff;
  justify-content: space-between;
  align-items: center;
  padding: 10px 17px;
  .h-left {
    display: flex;
    align-items: center;
    > img {
      height: 22px;
      margin-left: 6px;
    }
  }
  i {
    font-size: 24px;
  }
  .anticon-user {
  }
  .anticon-user-add {
    background: #ffa200;
    padding: 4px 12px;
    border-radius: 4px;
    color: white;
    margin-left: 6px;
  }
}
.tabBar {
  display: flex;
  padding-right: 20px;
  align-items: center;
  font-size: 0;
  // min-width: 900px;
  // padding-top: 34px;
  // margin: 0 auto;
  .menu-wrap {
    flex: 1;
  }
}
.content {
  width: 100%;
  margin: 0 auto;
  min-width: 1400px;
}

.ant-dropdown-menu-item {
  text-align: center !important;
}
.modalBody {
  .bodyHhd {
    overflow-y: auto;
    height: 420px;
    padding: 10px;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
      background: rgba(6, 6, 13, 0.2);
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: #eee;
    }
    .byItem {
      position: relative;
      padding: 20px 20px 20px 30px;
      border-radius: 4px;
      margin-bottom: 20px;
      background: #fff;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
      &::before {
        position: absolute;
        content: '';
        top: 50%;
        left: 20px;
        width: 6px;
        height: 6px;
        margin-top: -3px;
        background: #3699ff;
        border-radius: 50%;
        z-index: 1;
      }
      a {
        font-size: 16px;
        color: #666;
        &:hover {
          color: #3699ff;
        }
      }
    }
  }
  .footerWrap {
    padding: 20px 10px 10px 10px;
    text-align: right;
    .rightWrap {
      float: right;
      width: 96px;
      height: 32px;
      font-size: 14px;
      line-height: 32px;
      color: #fff;
      border-radius: 4px;
      background: #3699ff;
      text-align: center;
      cursor: pointer;
    }
  }
}
.layout_content {
  min-height: calc(100vh - 66px);
  background: #fafafa;
}
.layout_sider {
  min-height: calc(100vh - 66px);
  background: #ffffff;
}
.content-mobile {
  display: none;
}
// 新增1366笔记本适配
@media (max-width: 1366px) {
  .header {
    min-width: 1400px;
    // .userNameText {
    //   display: none;
    // }
  }
}
@media (min-width: 1500px) {
  .header {
    min-width: 1500px;
  }
}
@media screen and (max-width: 960px) {
  .header {
    display: none;
  }
  .header-mobile {
    display: flex;
    .cart-sp {
      position: relative;
      cursor: pointer;
      .badge-wrap {
        position: absolute;
        top: -10px;
        right: 10px;
      }
    }
  }
  .content {
    display: none;
  }
  .content-mobile {
    display: flex;
    .layout_content {
      min-height: calc(100vh - 44px);
      width: 100%;
    }
  }
}
.head_system_notice {
  color: #ffa200;
  background: #f3ece1;
  border: 1px solid #f48900;
  padding: 6px;
  text-align: center;
  img {
    width: 24px;
  }
}
</style>
